import React from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import Kpi from '../Kpi';
import { PlaylistAddCheckCircle } from '@mui/icons-material';
import { decode } from 'base-64';

const KpiScore = ({ children }) => {
    const { username } = useParams();
    const location = useLocation();
    const path = location.pathname;
    const split = path.split('/');

    const type = localStorage.getItem('type');

    return (
        <Kpi>
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="sub-menu">
                            <ul>
                                {
                                    decode(JSON.parse(type)) === 'direksi' || decode(JSON.parse(type)) === 'admin' ? 
                                    <li>
                                        <Link to={`/${username}/kpi/score/form`} className={` sub-menu-item ${split[4] === 'form'? 'active' : ''} `} >
                                            <div className="me-2">
                                                <PlaylistAddCheckCircle />
                                            </div>
                                            <span>Input KPI Skor</span>
                                        </Link>
                                    </li> : ''
                                }
                                <li>
                                    <Link to={`/${username}/kpi/score/data`} className={` sub-menu-item ${split[4] === 'data'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <PlaylistAddCheckCircle />
                                        </div>
                                        <span>Data KPI Skor</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
                
            { children }
        </Kpi>
    )
}

export default KpiScore
